import tippy from 'tippy.js'

export function initProductTips() {
  const elements = document.querySelectorAll('.js-product-tips')

  for (const element of elements) {
    const content = element.dataset['tips']
    tippy(element, {
      content,
      placement: 'bottom',
      animation: 'fade'
    })
  }
}
